import React from "react";
import moment from "moment";

type BlogTitleProps = {
  title: string;
  date: string;
  tag?: string;
  position?: string;
  margin?: string;
  spacing?: string;
};

const BlogTitle = ({
  title,
  date,
  tag,
  position,
  margin,
  spacing
}: BlogTitleProps) => {
  moment.locale("ID");

  return (
    <div>
      <div className="blog-title-wrapper">
        {tag && <div className="blog-title-tag">{tag}</div>}
        <h1 className="blog-title-title" style={{ fontWeight: "bold" }}>
          {title}
        </h1>
        <div className="blog-title-date">{moment(date).format("LL")}</div>
      </div>
      <style jsx>
        {`
          .blog-title-date {
            color: #a9a9a9;
            font-weight: bold;
            margin: ${spacing ? spacing : "12px 0"};
          }
          .blog-title-wrapper {
            display: flex;
            flex-direction: column;
            // align-items: ${position ? position : "center"};
            margin: ${margin ? margin : "24px 24px 0"};
            text-align: ${position ? position : "center"};
          }
          .blog-title-tag {
            color: var(--color-red);
            font-weight: bold;
            margin: ${spacing ? spacing : "0 0 24px"};
          }
          @media only screen and (max-width: 730px) {
            .blog-title-title {
              font-size: 17px;
            }
            .blog-title-date {
              font-size: 12px;
            }
            .blog-title-wrapper {
              text-align: left;
              align-items: flex-start;
            }
          }
        `}
      </style>
    </div>
  );
};
export { BlogTitle };
